import { useEffect } from 'react';
import { useLoggedIn } from 'bv-hooks';
import withLazyLoad from 'bv-lazy-load';
import { v as bvVar } from 'bv';
import OccupationAndSalary from 'Registration/components/occupation_and_salary';
import { get, remove } from 'bv-local-storage';
import { locationCheckTimer } from 'Login/services/location_check_timer';
import UserMessages from './user_messages';
import SelfExclusionSuccessCheck from './self_exclusion_success_check';
import showBetslipParamCheck from './show_betslip_param_check';
import sessionExpired from './session_expired';
import zendeskLoader from './zendesk_loader';
import Connectivity from './connectivity';
import balanceUpdater from './balance_updater';
import ChatPreloaderView from './live_chat_preloader_view';

const EnhancedOutcomeOffers = withLazyLoad()('enhancedOutcomeOffers');

const ServicesView = () => {
  showBetslipParamCheck();
  sessionExpired();
  zendeskLoader();

  const loggedIn = useLoggedIn();

  useEffect(() => {
    if (loggedIn && get('need_location_check')) {
      locationCheckTimer();
    } else {
      remove('need_location_check');
    }
    if (loggedIn) {
      balanceUpdater();
      document.title = bvVar('siteName');
    }
  }, [loggedIn]);

  if (!loggedIn) {
    return (
      <>
        <ChatPreloaderView />
        <SelfExclusionSuccessCheck />
      </>
    );
  }

  return (
    <>
      <ChatPreloaderView />
      <UserMessages />
      <EnhancedOutcomeOffers />
      <OccupationAndSalary />
      <Connectivity />
    </>
  );
};

export default ServicesView;
